<template>
  <k-form-section legend="Meeting Link" class="set-meeting-link">
    <k-form-field
      label="Link"
      :field-id="inputId"
      :required="true"
      class="meeting-link-field"
    >
      <div class="meeting-link-row">
        <div class="meeting-link-input-container">
          <input
            :id="inputId"
            class="form-control"
            :value="modelValue"
            type="url"
            :maxlength="maxLength"
            placeholder="Enter the meeting link here"
            @input="onInput"
          >
          <k-character-count
            :value-length="modelValue.length"
            :max-length="maxLength"
          />
        </div>
        <generate-teams-link-button
          :learner-user-id="learnerUserId"
          :module-meeting-id="moduleMeetingId"
          :meeting-id="meetingId"
          :is-ad-hoc="isAdHoc"
          :start-time="startTime"
          :end-time="endTime"
          @generated="onTeamsLinkGenerated"
        />
      </div>
      <span v-if="showValidationMessage" class="helper-text">{{ urlValidationMessage }}</span>
    </k-form-field>
  </k-form-section>
</template>

<style scoped>
.helper-text {
  font-size: 0.9em;
  color: var(--kate-type-secondary) !important;
  margin: 0;
  font-style: italic;
  display: block;
}

.meeting-link-row {
  display: flex;
  gap: 10px;
}

.meeting-link-input-container {
  width: 100%;
  display: flex;
  align-items: flex-end;
  flex-direction: column;
}

.meeting-link-field {
  flex: 1;
  min-width: 0;
}
</style>

<script>
import { KFormSection, KFormField, KCharacterCount } from '@base-components/forms';
import useGlobalStore from '@stores/global';
import GenerateTeamsLinkButton from './generate-teams-link-button.vue';

export default {
  name: 'set-meeting-link',

  components: {
    KFormSection,
    KFormField,
    KCharacterCount,
    GenerateTeamsLinkButton,
  },

  props: {
    modelValue: {
      type: String,
      default: '',
    },
    learnerUserId: {
      type: Number,
      default: null,
    },
    moduleMeetingId: {
      type: Number,
      default: null,
    },
    meetingId: {
      type: Number,
      default: null,
    },
    isAdHoc: {
      type: Boolean,
      default: false,
    },
    startTime: {
      type: Date,
      default: null,
    },
    endTime: {
      type: Date,
      default: null,
    },
    inputId: {
      type: String,
      required: true,
    },
    maxLength: {
      type: Number,
      default: 2048,
    },
  },

  emits: ['update:modelValue', 'validation', 'teams-metadata-changed'],

  computed: {
    urlValidation() {
      return this.$validator.urlValidator(this.modelValue);
    },
    isValid() {
      return Boolean(this.modelValue) && this.urlValidation.isValid;
    },
    showValidationMessage() {
      return this.modelValue && !this.urlValidation.isValid;
    },
    urlValidationMessage() {
      return this.urlValidation.message;
    },
  },

  watch: {
    isValid: {
      handler(isValid) {
        this.$emit('validation', { isValid });
      },
      immediate: true,
    },
  },

  methods: {
    onInput(event) {
      this.$emit('teams-metadata-changed', null);
      this.$emit('update:modelValue', event.target.value);
    },
    onTeamsLinkGenerated({ joinLink, teamsMeetingId }) {
      this.$emit('update:modelValue', joinLink);
      this.$emit('teams-metadata-changed', {
        teamsMeetingId,
        teamsOrganiserUserId: useGlobalStore().userId,
      });
    },
  },
};
</script>
